import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useAuth } from '../AuthContext';
import AOS from 'aos';
import 'aos/dist/aos.css';

import SkelotonEffect from './SkelotonEffect';
import InternalBanner from './InternalBanner';
const apiKey = process.env.REACT_APP_API_KEY;
const baseURL = process.env.REACT_APP_BASE_URL;
const userId = localStorage.getItem('userid');
const API_URL = `${baseURL}/books/`;
const headers = {
    'Authorization': apiKey,
    'accept': 'application/json',
    'Content-Type': 'application/json'
};

export default function BookByLanguageCatWise() {

    const [languageData, setLanguageData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedBook, setSelectedBook] = useState(null);
    const [error, setError] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const { languageID } = location.state || {};
    const { isAuthenticated } = useAuth();
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            const params = {
                author_id: 0,
                book_cat: 0,
                itemcount: 24,
                language_id: languageID,
                offsetvalue: offset,
                publisher: false,
                search_word: "null",
                type_title: "Category",
                userid: userId
            };

            try {
                const response = await axios.post(API_URL, params, { headers });
                if (response.data.length === 0) {
                    toast.success("No more books available.");
                } else {
                    setLanguageData(response.data);
                }

            } catch (error) {
                setError(error);
            } finally {
                setIsLoading(false);
            }

            AOS.init({
                duration: 1200,
            });
        };

        fetchData();
    }, [languageID, offset]);

    const handleClicknew = () => {
        const fileLink = selectedBook.book_link;
        const bookId = selectedBook._id;
        const fileExtension = fileLink.split('.').pop();

        if (fileExtension === 'pdf') {
            navigate('/pdf', { state: { message: fileLink, id: bookId } });
        } else if (fileExtension === 'epub') {
            navigate('/epub', { state: { message: fileLink, id: bookId } });
        } else {
            console.error('Unsupported file type');
        }
    };


    const handleActionClick = () => {
        if (!isAuthenticated) {
            handleReadMoreClick();
        } else {
            handleClicknew();
            document.body.classList.remove("remove-scroll");
        }
    };
    const handleReadMoreClick = () => {
        const fileLink = selectedBook.book_link;
        const bookId = selectedBook._id;
        navigate('/login', { state: { message: fileLink, id: bookId  } });  
    };

    const openModal = (agegroup) => {
        setSelectedBook(agegroup);
        setShowModal(true);
        document.body.classList.add("remove-scroll");
    };


    const closeModal = () => {
        setShowModal(false);
        setSelectedBook(null);
        document.body.classList.remove("remove-scroll");
    };

    const goBack = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.history.length > 1) {
            navigate(-1);
            setTimeout(() => window.scrollTo(0, 0), 0);
        } else {
            alert('No history available to go back.');
        }
    };

    useEffect(() => {
        document.body.classList.remove("remove-scroll");
    }, [location]);


    const renderStars = (rating) => {
        const fullStars = Math.floor(rating);
        const halfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

        return (
            <>

                {Array.from({ length: fullStars }, (_, i) => (
                    <i key={`full-${i}`} className="active icofont-star"></i>
                ))}
                {halfStar && <i className="half icofont-star"></i>}
                {Array.from({ length: emptyStars }, (_, i) => (
                    <i key={`empty-${i}`} className="inactive icofont-star"></i>
                ))}
            </>
        );
    };

    const handleNext = () => {
        setOffset((prev) => {
            const newOffset = prev + 1;
            return newOffset;
        });
    };
    const handlePrevious = () => {
        setOffset((prev) => {
            if (prev > 0) {
                const newOffset = prev - 1;
                return newOffset;
            }
            return prev;
        });
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                theme="dark"
            />

            {languageData.length > 0 && (
                <InternalBanner title={languageData[0].language} />
            )}

            {selectedBook && (
                <>
                    <div className="modal my_modal" style={{ display: showModal ? 'block' : 'none' }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000" >
                                <button className="modal-close icofont-close" onClick={closeModal}></button>
                                <div className="product-view">

                                    <div className="col-md-12 col-lg-12">
                                        <div className="row view-gallery">

                                            <div className='col-md-4 col-5'>
                                                <img src={!selectedBook.book_cover_img ? "https://ndl.education.gov.in/upload/book_place_holder.jpg" : selectedBook.book_cover_img} alt="Book Cover" className="img-fluid mb-3 w-100" />
                                            </div>
                                            <div className='col-md-8 col-7'>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <h3 className="view-name">
                                                            {selectedBook.book_title}

                                                        </h3>
                                                        <div className='moddal_rating_info'>
                                                            {!!selectedBook.avg_rating && (
                                                                <>
                                                                    {renderStars(selectedBook.avg_rating)}
                                                                    <h4 className="info-ans ms-2">{selectedBook.avg_rating.toFixed(1)}</h4>

                                                                </>
                                                            )}
                                                        </div>

                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className="table_modal">
                                                            <div className="info-authors">

                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.author_name && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/authors.png`} alt="authors" /><span className='desktop-view'>Authors</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.author_name}</h4>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.publisher_name && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/publications.png`} alt="publications" /><span className='desktop-view'>publisher</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.publisher_name}</h4>
                                                                    </div>
                                                                )}

                                                            </div>

                                                            <div className="info-authors">
                                                                {selectedBook.book_pages && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/pages.png`} alt="pages" /><span className='desktop-view'>Total Number of pages</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.book_pages}</h4>
                                                                    </div>
                                                                )}

                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.book_year && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/years.png`} alt="years" /><span className='desktop-view'>Book Year </span></h4>
                                                                        <h4 className="info-ans">{selectedBook.book_year}</h4>
                                                                    </div>
                                                                )}
                                                            </div>


                                                            <div className="info-authors">
                                                                {selectedBook.category_name && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/Genre.png`} alt="Genre" /><span className='desktop-view'>Book Category Name </span></h4>
                                                                        <h4 className="info-ans">{selectedBook.category_name}</h4>
                                                                    </div>
                                                                )}

                                                            </div>
                                                            <div className="info-authors">
                                                                {selectedBook.download_count && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/download_count.png`} alt="download count" /><span className='desktop-view'>Download Count</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.download_count}</h4>
                                                                    </div>
                                                                )}

                                                            </div>
                                                            <div className="info-authors ">
                                                                {selectedBook.language && (
                                                                    <div className='moddal_info'>
                                                                        <h4 className="info-ttl"><img src={`${process.env.PUBLIC_URL}/assets/images/modal_icons/language.png`} alt="language" /><span className='desktop-view'>Language</span> </h4>
                                                                        <h4 className="info-ans">{selectedBook.language}</h4>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className="view-details">
                                                    <h3 className="view-name">
                                                        Book Summary
                                                    </h3>
                                                    <p className="view-desc">{selectedBook.book_desc}</p>
                                                </div>
                                                <div className="info-authorss ">
                                                    <button onClick={handleActionClick} className='btn-6 view-all-btnn mb-3'>Read <i className="fas fa-long-arrow-alt-right"></i></button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )}


            {error ? (
                <section className="error-part">
                    <div className="container">
                        <h1 className='mb-4 d-none'>{error.message}</h1>
                        <img className="img-fluid mb-3" src="assets/images/error.png" alt="error" />

                    </div>
                </section>

            ) : isLoading ? (
                <SkelotonEffect />
            ) : (
                <div className='container-fluid'>
                    <div className='row bg-body-color'>

                        {languageData && (

                            <section id="nutrition" className='books py-4'>

                                <div className='container space-container'>
                                    <div className='col-md-12'>
                                        <button className="btn-6 view-all-btnn mb-4" onClick={goBack} ><i className="fas fa-long-arrow-alt-left me-2"></i>Back </button>
                                    </div>
                                    <div className='col-md-12'>
                                        <div className='row row-cols-2 row-cols-md-3 row-cols-lg-4 px-3 row-cols-xl-6'>
                                            {languageData.map(language => (
                                                <div key={language._id} className='col mb-4' onClick={() => openModal(language)}>
                                                    <div className='img-card book_style'>
                                                        <div className='product-media'>
                                                            <div className="product-image">
                                                                <div className="_df_thumb df-element df-popup-thumb df-tl-book-title-hover">
                                                                    <div className="df-book-wrapper">
                                                                        <div className="df-book-page1">
                                                                        </div>
                                                                        <div className="df-book-page2">
                                                                        </div>
                                                                        <div className="df-book-cover df-icon-play-popup">
                                                                            <img
                                                                                src={language.book_cover_img}
                                                                                className='w-100'
                                                                                alt="Book Cover"
                                                                                onError={(e) => {
                                                                                    if (!e.currentTarget.dataset.fallback) {
                                                                                        e.currentTarget.dataset.fallback = "true"; // Mark that fallback is applied
                                                                                        e.currentTarget.src = "/assets/images/elements/book_cover.png"; // Use absolute path if in public folder
                                                                                    }
                                                                                }}
                                                                                style={{ cursor: 'pointer' }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='book-content'>
                                                        <h6 className="book-name">
                                                            {language.book_title}
                                                        </h6>
                                                        <p>
                                                            <span>Author :</span> {language.author_name}
                                                        </p>
                                                        <div className="product-rating">
                                                            {renderStars(language.avg_rating)}
                                                        </div>
                                                        <div className="product-rating">
                                                            <span className='rating-text'>{language.avg_rating.toFixed(1)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                    </div>
                                    <div className='col-md-12 text-end mt-4'>
                                        <button onClick={handlePrevious} disabled={offset === 0} className="btn f_increase view-all-btnn me-2"><i className="fas fa-caret-left"></i></button>
                                        <button onClick={handleNext} className="btn f_increase view-all-btnn me-2"><i className="fas fa-caret-right"></i></button>
                                    </div>
                                </div>
                            </section>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}
